import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

const app = createApp(App)

document.documentElement.style.setProperty('--el-color-primary', '#A84110')
document.documentElement.style.setProperty('--el-color-primary-dark-2', '#8A350D')
document.documentElement.style.setProperty('--el-color-primary-light-3', '#D4591A')
document.documentElement.style.setProperty('--el-color-primary-light-5', '#E8A070')
document.documentElement.style.setProperty('--el-color-primary-light-7', '#F0C4A0')
document.documentElement.style.setProperty('--el-color-primary-light-9', '#F5E6DC')

app.use(router).use(ElementPlus).mount('#app')

import { Store } from './utils/store'
window.onresize = function() {
  Store.changeScreen();
}

